export type WeightPreset = {
  conditions: number;
  quiet: number;
  value: number;
};

export const WEIGHT_PRESETS: Record<string, WeightPreset> = {
  balanced: { conditions: 0.50, quiet: 0.30, value: 0.20 },
  conditions: { conditions: 0.70, quiet: 0.20, value: 0.10 },
  crowds: { conditions: 0.25, quiet: 0.60, value: 0.15 },
  value: { conditions: 0.35, quiet: 0.25, value: 0.40 },
};

export const PRESET_LABELS: Record<string, string> = {
  balanced: "Balanced",
  conditions: "Best conditions",
  crowds: "Avoid crowds",
  value: "Best value",
};
